import { useTenantConfig } from 'contexts';
import { CommonRegionPickerProps } from 'types';
import { PopupTerminalPickerDesktop } from './desktop/PopupTerminalPickerDesktop';
import { PopupTerminalPickerMobile } from './mobile/PopupTerminalPickerMobile';

export type PopupTerminalPickerProps = Pick<
  CommonRegionPickerProps,
  'showPopup' | 'onClosePopup'
> & {};
export const PopupTerminalPicker = ({ ...props }: PopupTerminalPickerProps) => {
  const { isMobile } = useTenantConfig();
  if (isMobile) {
    return <PopupTerminalPickerMobile {...props} />;
  }

  return <PopupTerminalPickerDesktop {...props} />;
};
